import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.03 7.97l4.97 -4.97l4 4l-5 5m-2 2l-7 7l-4 -4l7 -7","key":"svg-0"}],["path",{"d":"M16 7l-1.5 -1.5","key":"svg-1"}],["path",{"d":"M10 13l-1.5 -1.5","key":"svg-2"}],["path",{"d":"M7 16l-1.5 -1.5","key":"svg-3"}],["path",{"d":"M3 3l18 18","key":"svg-4"}]]

const IconRuler2Off = createReactComponent('outline', 'ruler-2-off', 'Ruler2Off', __iconNode);

export default IconRuler2Off;